import { render, staticRenderFns } from "./OrderPollingList.vue?vue&type=template&id=919f140a&"
import script from "./OrderPollingList.vue?vue&type=script&lang=ts&"
export * from "./OrderPollingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports